import { Leaf } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const ImpactInfoBannerJadlog = () => {
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="info" className="border-0">
        <div className="bg-[#ECFDF5] border border-[#A7F3D0] rounded-xl overflow-hidden">
          <AccordionTrigger className="px-4 py-3 hover:no-underline [&[data-state=open]>div>svg]:rotate-0">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-[#D1FAE5] rounded-lg flex-shrink-0">
                <Leaf className="h-5 w-5 text-[#059669]" />
              </div>
              <h3 className="font-medium text-[#10261F]">Sobre estes dados</h3>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4 pt-0">
            <p className="text-sm text-gray-600 leading-relaxed ml-12">
              Os indicadores são calculados com base na massa total de resíduos destinados corretamente.
            </p>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
};
